import { render } from "./Herder.vue?vue&type=template&id=e4bedcea"
import script from "./Herder.vue?vue&type=script&lang=js"
export * from "./Herder.vue?vue&type=script&lang=js"

import "./Herder.vue?vue&type=style&index=0&id=e4bedcea&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__